module.exports = __webpack_public_path__ + "img/framework-img.34a3ae76.png";